import React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { COLORS, fontFamilyAll } from '../assets/commonComponents/COLORS';
import CloseIcon from '@mui/icons-material/Close';
import { Typography } from '@mui/material';
import { WhiteAppBar,DrawerContent } from '../assets/css/appbar';

function NavigationBar({logo,isMobile,drawerOpen, toggleDrawer,handleScroll,navigationData}) {

  return (
    
    <><WhiteAppBar position="fixed" sx={{ minHeight: 90, justifyContent: 'center' }}>
          <Toolbar sx={{ justifyContent: 'space-between', px: 2 }}>
              <Box component="img" src={logo} alt="Company Logo" sx={{ height: 50 }} />
              {isMobile ? (
                  <IconButton edge="end" color="inherit" onClick={toggleDrawer(true)}>
                      <MenuIcon sx={{ color: COLORS.pinkColor }} />
                  </IconButton>
              ) : (
                  <Box sx={{ display: 'flex', gap: 3 }}>
                      {navigationData.map((item) => (
                          <Typography
                           key={item} 
                           onClick={() => handleScroll(item)}
                            sx={{ color: COLORS.pinkColor,
                                transition: 'color 0.3s',
                                cursor: 'pointer',
                                fontFamily:fontFamilyAll,
                                fontWeight: 'bold',
                                '&:hover': { color:COLORS.purpleColor },
                                '&:active': { color:COLORS.purpleColor },
                             textTransform: 'capitalize' }}>
                              {item}
                          </Typography>
                      ))}
                  </Box>
              )}
          </Toolbar>
      </WhiteAppBar><Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
              <DrawerContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '95%', alignItems: 'center' }}>
                      <Box component="img" src={logo} alt="Company Logo" sx={{ height: 50 }} />
                      <IconButton onClick={toggleDrawer(false)} sx={{ color: '#fff' }}>
                          <CloseIcon />
                      </IconButton>
                  </Box>
                  <List sx={{ mt: 4, width: '100%' }}>
                      {navigationData.map((item) => (
                          <ListItem button key={item} onClick={() => handleScroll(item)}>
                              <ListItemText fontWeight="bold" primary={item} sx={{ color: '#fff', textAlign: 'left', fontSize: '18px',
                    '& .MuiListItemText-primary': {
                      fontFamily: fontFamilyAll,
                    },
                    '&:hover': { color:COLORS.pinkColor},
                                '&:active': { color:COLORS.pinkColor }, }} />
                          </ListItem>
                      ))}
                  </List>
              </DrawerContent>
          </Drawer></>
  )
}

export default NavigationBar